// Må stå først: setter opp window/self/global som SSR (ClearScript V8) mangler
import './ssr-globals';

// Polyfill for TextEncoder som brukes av react-dom/server i React 18
import 'fastestsmallesttextencoderdecoder/EncoderDecoderTogether.min';

// Polyfill for queueMicrotask som Reacts scheduler bruker etter implementasjon av nytt filter (ref PBI 382988)
import './polyfills/queueMicrotask';

// Midlertidig polyfill for URL som mangler i SSR (ClearScript V8)
import './polyfills/url';

// All JavaScript in here will be loaded server-side
import React from 'react';

import * as amplitude from '@amplitude/analytics-browser';
import DOMPurify from 'dompurify';
import ReactDOM from 'react-dom';
import ReactDOMClient from 'react-dom/client';
import ReactDOMServer from 'react-dom/server';

// Expose components globally so ReactJS.NET can use them
globalThis.React = React;
globalThis.ReactDOM = ReactDOM;
globalThis.ReactDOMClient = ReactDOMClient;
globalThis.ReactDOMServer = ReactDOMServer;
globalThis.DOMPurify = DOMPurify;
globalThis.Amplitude = amplitude;
